const options = {
  5: "bg-blue-800/5",
  10: "bg-blue-800/10",
  25: "bg-blue-800/25",
  50: "bg-blue-800/50",
  75: "bg-blue-800/75",
  90: "bg-blue-800/90",
  100: "bg-blue-800",
};

const from = {
  5: "from-blue-800/5",
  10: "from-blue-800/10",
  25: "from-blue-800/25",
  50: "from-blue-800/50",
  75: "from-blue-800/75",
  90: "from-blue-800/90",
  100: "from-blue-800",
};

export default function getBackgroundBlue800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
